module.exports = __webpack_public_path__ + "37845e53ccc33dbb9d863093375e96d9.bg_main_mid.webp";


//////////////////
// WEBPACK FOOTER
// ./components/whyUsSection/assets/bg_main_mid.webp
// module id = q6VP
// module chunks = 0